import './dateTransform';

import { object } from 'yup';

import { createCommonSchema } from '@/validation';

const dueValidation = (initialValues, errorMessages) =>
  object().shape(createCommonSchema(initialValues)?.(errorMessages));

export default dueValidation;
